export function slugify(name) {
  return name
    .toLowerCase()
    .replace(/[''`]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function findCompanyBySlug(companies, slug) {
  return companies.find((c) => slugify(c.Name) === slug);
}
